/* Revele les blocs Lumina au defilement : retire scroll-trigger--offscreen,
   comme le fait le theme source. Sans cela les sections restent a opacity .01. */
(function () {
  function reveal() {
    var els = document.querySelectorAll('.at-lumina .scroll-trigger--offscreen');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (e) { e.classList.remove('scroll-trigger--offscreen'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.remove('scroll-trigger--offscreen');
        en.target.classList.add('scroll-trigger--active');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -40px 0px' });
    Array.prototype.forEach.call(els, function (e) { io.observe(e); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal);
  else reveal();
  window.addEventListener('load', reveal);
})();
